//#region libraries
import { useEffect, useState } from 'react';

// custom components
import { CustomSpinner } from '_atoms';

// bootstrap
import { Button, Col, Container, Form, Row } from 'react-bootstrap';

// redux
import { useDispatch, useSelector, } from 'react-redux';
import { selectIata } from '_redux/slices/main-screen/user';
import { selectAirportInformation } from '_redux/slices/analytics/reviews';
import { selectUserDb } from '_redux/slices/main-screen/user';
import { getBeaconSubmittedTimes, getWaitingTimes, postMinor, selectBeaconsError, selectBeaconsPostStatus, selectWaitingTimes, setError, setSelectedBeacon as setSliceSelectedBeacon } from '_redux/slices/beacons/beacons';

// utils
import { Colors } from '_styles';
import {
    Accordion,
    AccordionHeader,
    Bold,
    Flex,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeaderCell,
    TableRow,
    Text,
    Title as TremorTitle
} from '@tremor/react';
import { FaChevronRight } from 'react-icons/fa';
//#endregion

const BeaconsSelector = (props) => {

    //#region redux + states
    const dispatch = useDispatch();
    const waitingTimes = useSelector(selectWaitingTimes);
    const error = useSelector(selectBeaconsError);
    const airportInformation = useSelector(selectAirportInformation)
    const iata = useSelector(selectIata);
    const dbUser = useSelector(selectUserDb)

    // local states
    const [minorDescription, setMinorDescription] = useState('')
    const [minorName, setMinorName] = useState('')
    const [minor, setMinor] = useState('')
    const [major, setMajor] = useState('')
    const [uuid, setUUID] = useState('')
    const [beaconId, setBeaconId] = useState('')
    const [edit, setEdit] = useState(false)
    const [errors, setErrors] = useState('')

    const postStatus = useSelector(selectBeaconsPostStatus)
    //#endregion

    // handle status update
    useEffect(() => {
        if (iata) {
            dispatch(getWaitingTimes({ iata: iata, }))
            // get submitted beacon times
            dispatch(getBeaconSubmittedTimes(iata))
        }
    }, [iata])

    useEffect(() => {
        if (postStatus == 'succeeded' && iata) {
            dispatch(getWaitingTimes({ iata: iata }))
            setMinorDescription('')
            setMinorName('')
            setMinor('')
            setMajor('')
            setBeaconId('')
            setUUID('')
        }
    }, [postStatus])

    useEffect(() => {
        if (error) {
            setError(error.toString())
        }
    }, [error])



    // delete iata
    const handleDetails = (beacon) => {
        dispatch(setSliceSelectedBeacon(beacon.details.beaconId))
        props.showBeaconDetails()
    }

    // add iata to list
    const createBeacon = () => {
        if (!(parseInt(minor))) {
            setErrors('Minor needs to be an integer')
        }
        else if (minorName.length <= 0) {
            setErrors('Description Name needs to be non empty')
        } else if (minor.length <= 0) {
            setErrors('Description needs to be non empty')
        }
        else { // add to list
            setErrors('')
            dispatch(postMinor({ major, minor, minorName, minorDescription, iata, beaconId, uuid }))
            setEdit(false)
        }
    }

    return (
        <>
            {/* List of Waiting Rooms */}
            <Row>
                <Col>

                    <Flex>
                        <Container>
                            <TremorTitle>{airportInformation && airportInformation[dbUser.details.authority] ? airportInformation[dbUser.details.authority].name : ''} Waiting Areas</TremorTitle>
                            <Text>View real-time information on how many passengers are waiting in your airport</Text>
                        </Container>
                    </Flex>

                    <Table marginTop='mt-2.5'>
                        <TableHead>
                            <TableRow>
                                <TableHeaderCell><Text><Bold>{'Area'}</Bold></Text></TableHeaderCell>
                                <TableHeaderCell><Text><Bold>{'Beacon ID'}</Bold></Text></TableHeaderCell>
                                <TableHeaderCell><Text><Bold>{'Major'}</Bold></Text></TableHeaderCell>
                                <TableHeaderCell><Text><Bold>{'Minor'}</Bold></Text></TableHeaderCell>
                                <TableHeaderCell><Text><Bold>{'Waiting Time'}</Bold></Text></TableHeaderCell>
                                <TableHeaderCell><Text><Bold>{''}</Bold></Text></TableHeaderCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {waitingTimes != undefined && waitingTimes.map((value) => (
                                <TableRow>
                                    <TableCell><Text truncate={true}>{value.details != undefined ? value.details.name : ''}</Text></TableCell>
                                    <TableCell><Text>{value.details != undefined ? value.details.beaconId : ''}</Text></TableCell>
                                    <TableCell><Text>{value.details != undefined ? value.details.major : ''}</Text></TableCell>
                                    <TableCell><Text>{value.details != undefined ? value.details.minor : ''}</Text></TableCell>
                                    <TableCell><Text>{value.time != undefined ? value.time : ''}</Text></TableCell>
                                    <TableCell><p onClick={() => handleDetails(value)} style={{ cursor: 'pointer', color: Colors.PRM_LIGHT_BLUE, fontWeight: '300' }}><FaChevronRight color={Colors.GRAY_DARK}></FaChevronRight></p></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Col>

                {/*<ColList start={0} end={8} />*/}

            </Row>

            {/* Buttons for Adding, Delete and Done */}
            <Row className='mt-5'>
                <Container>
                    <Accordion className='mt-2'>

                        <AccordionHeader>Add Beacon</AccordionHeader>

                        <div style={{ marginLeft: 26, marginTop: 8 }}>
                            <Form>
                                <Row>
                                    <Col>
                                        <Text>Name</Text>
                                        <Form.Control className='mt-3' onChange={(e) => { setMinorName(e.target.value) }} type="name" placeholder="" style={{ borderColor: errors.length > 0 ? 'red' : '' }} value={minorName} />
                                    </Col>
                                    <Col>
                                        <Text>Description</Text>
                                        <Form.Control className='mt-3' onChange={(e) => { setMinorDescription(e.target.value) }} type="name" placeholder="" style={{ borderColor: errors.length > 0 ? 'red' : '' }} value={minorDescription} />
                                    </Col>
                                    <Col>
                                        <Text>UUID</Text>
                                        <Form.Control className='mt-3' onChange={(e) => { setUUID(e.target.value) }} type="name" placeholder="" style={{ borderColor: errors.length > 0 ? 'red' : '' }} value={uuid} />
                                    </Col>
                                    <Col>
                                        <Text>Beacon ID (Optional)</Text>
                                        <Form.Control className='mt-3' onChange={(e) => { setBeaconId(e.target.value) }} type="name" placeholder="" style={{ borderColor: errors.length > 0 ? 'red' : '' }} value={beaconId} />
                                    </Col>
                                    <Col>
                                        <Text>Major</Text>
                                        <Form.Control className='mt-3' onChange={(e) => { setMajor(e.target.value) }} type="name" placeholder="" style={{ borderColor: errors.length > 0 ? 'red' : '' }} value={major} />
                                    </Col>
                                    <Col>
                                        <Text>Minor</Text>
                                        <Form.Control className='mt-3' onChange={(e) => { setMinor(e.target.value) }} type="name" placeholder="" style={{ borderColor: errors.length > 0 ? 'red' : '' }} value={minor} />
                                    </Col>
                                    <Col className='mt-3'>
                                        <Button
                                            onClick={() => { createBeacon() }}
                                            variant={"outline-primary"}
                                            style={{
                                                width: 200,
                                                borderColor: error && error.length > 0 ? 'red' : 'null',
                                                color: error && error.length > 0 ? 'red' : 'null',
                                            }}
                                            loading={true}
                                            className="mt-3">
                                            {
                                                postStatus == 'loading' ? <CustomSpinner />
                                                    :
                                                    'Add New Beacon'
                                            }
                                        </Button>
                                        {
                                            error && error.length > 0 ? <p style={{ color: 'red', fontSize: 12 }}>{error}</p> : ''
                                        }
                                    </Col>
                                </Row>
                            </Form>
                            {
                                errors.length > 0 &&
                                <p style={{ color: 'red', fontSize: 12 }}>{errors}</p>
                            }
                            <div style={{ marginBottom: 25 }} />
                        </div>
                    </Accordion>
                </Container>

            </Row>
        </>
    )
};

export default BeaconsSelector;